import { isFalsy, isNotNilOrEmpty } from 'lib/Helpers';

import { findAppendix } from '../Currency';

/**
 * Converts an intenger to short hand string
 * @function convertNumberToShortHand
 * @param {number} num
 * @param {number} decimalPlaces
 * @return {string}
 */
const convertNumberToShortHand = (num, decimalPlaces = 1) => {
  if (isFalsy(isNotNilOrEmpty(num))) return null;
  /* If number is less than 1000 - no conversions necessary. */
  if (num < 1000) return num.toString();

  /* Find decimal values by dividing by 1000 */
  let numCopy = num;
  while (numCopy >= 1000) numCopy /= 1000;

  /* String version of numCopy for string formatting */
  const copyString = numCopy.toString();
  /* Find trailing appendix value K, M, B, T, etc. */
  const appendix = findAppendix(
    /**
     * Properly handles float values being passed to findAppendix
     * Checks if there's already a decimal in the original value
     * Formats value properly to receive correct appendix string
    */
    num.toString().indexOf('.') !== -1
      ? num.toString().slice(0, num.toString().indexOf('.'))
      : num.toString()
  );
  /* Find decimal location (if exists) */
  const hasDecimal = copyString.indexOf('.');
  /* Store forced decimal additions if num is whole, but decimalPlaces wanted */
  const temp = hasDecimal === -1
    /* Add as many zeroes as developer specifies to show */
    ? numCopy.toFixed(decimalPlaces).toString()
    : '';
  /* Find the value prefix */
  const prefix = hasDecimal !== -1
    ? copyString.slice(0, hasDecimal)
    : copyString;
  /* Find the appropriate decimal value after prefix */
  const decimal = hasDecimal !== -1
    ? copyString.slice(hasDecimal, hasDecimal + decimalPlaces + 1)
    : temp.slice(temp.indexOf('.'));

  return `${prefix}${decimal}${appendix}`;
};

export default convertNumberToShortHand;
